module.exports = __webpack_public_path__ + "img/service4.6ebcee98.jpg";